import(/* webpackMode: "eager" */ "/home/runner/work/happyhours/happyhours/app/[locale]/addbar/[[...barId]]/page.tsx");
